import * as React from "react";
import {
  Button,
  Box,
} from "@mui/material";

import { Controller, useForm } from "react-hook-form";
import { Project, ProjectTask } from "../../types/project";
import LoadingButton from "@mui/lab/LoadingButton";
import { DesktopDateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { BaseModal, StyledTextField } from "../../components/global";
import { useUILabel } from "../../hooks/useUILabel";

interface ModalTaskFormProps {
  open: boolean;
  onClose: () => void;
  data: ProjectTask | null;
  onAdd?: (task: ProjectTask) => void;
}

const ModalTaskForm = ({ open, onClose, data, onAdd }: ModalTaskFormProps): React.ReactElement => {
  const {
    handleSubmit,
    clearErrors,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  // UI Labels
  const createTaskLabel = useUILabel("project.createTask");
  const editTaskLabel = useUILabel("project.editTask");
  const taskNameLabel = useUILabel("project.taskName");
  const taskDescriptionLabel = useUILabel("project.taskDescription");
  const cancelLabel = useUILabel("common.cancel");
  const createLabel = useUILabel("common.create");
  const updateLabel = useUILabel("common.update");
  const thisFieldIsRequiredLabel = useUILabel("common.thisFieldIsRequired");

  const onSubmit = async (payload: any) => {
    if (!data) {
      payload.id = Date.now();
      if (onAdd) onAdd(payload);
      return;
    }
    // try {
    //   if (!data) await add(payload).unwrap();
    //   else {
    //     if (!payload.password) delete payload.password;
    //     payload.id = data?.id!;
    //     await edit(payload).unwrap();
    //   }
    //   onClose();
    // } catch (err) {
    //   onClose();
    // }
  };

  React.useEffect(() => {
    if (open) {
      setValue("name", data?.name);
      setValue("description", data?.description);
      // setValue("start_date", data?.start_date || null);
      clearErrors();
    }
  }, [data, open]);

  const formRef = React.useRef<HTMLFormElement>(null);

  const footer = (
    <>
      <Button onClick={onClose}>{cancelLabel}</Button>
      <LoadingButton
        onClick={() => formRef.current?.requestSubmit()}
        variant="contained"
        loading={false}
      >
        {!data ? createLabel : updateLabel}
      </LoadingButton>
    </>
  );

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={!data ? createTaskLabel : editTaskLabel}
      footer={footer}
      maxWidth="sm"
    >
      <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ 
          p: 2.5, 
          display: "flex", 
          flexDirection: "column", 
          gap: 2, 
          maxHeight: "calc(100vh - 250px)", 
          overflowY: "auto",
          "@media (orientation: landscape) and (max-width: 900px)": {
            p: { xs: 1.5, sm: 2 },
            gap: { xs: 1.5, sm: 2 },
            maxHeight: "calc(90vh - 140px)",
          },
        }}>
          <Controller
            name="name"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <StyledTextField
                label={taskNameLabel}
                value={value || ""}
                fullWidth
                onChange={onChange}
                onBlur={onBlur}
                error={!!errors.name}
                helperText={!!errors.name && thisFieldIsRequiredLabel}
              />
            )}
          />
          <Controller
            name="description"
            control={control}
            rules={{ required: false }}
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <StyledTextField
                label={taskDescriptionLabel}
                value={value || ""}
                fullWidth
                minRows={3}
                multiline={true}
                onChange={onChange}
                onBlur={onBlur}
                error={!!errors.description}
                helperText={!!errors.description && thisFieldIsRequiredLabel}
              />
            )}
          />
        </Box>
      </form>
    </BaseModal>
  );
};
export default ModalTaskForm;
